import React, { useState } from 'react';
import fr from 'facet-rest';

import useUserContext from 'Context/UserContext';
import AuthenticationFactorListOrganism from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDBodyText, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useRefreshAuthenticationFactors } from 'Hooks/useRefreshEvent';
import Container from './Container';
import { AuthenticationFactorProvider } from './Context';

const AuthenticationFactorComponent = () => {
  const { userResource } = useUserContext();
  const { pageContentResource, loadPageContentLink, refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const onClick = (rel) => {
    setLoading(true);
    try {
      loadPageContentLink(rel.link('related'));
      // We don't need to set loading back to true because this component will unmount
    } catch (err) {
      setLoading(false);
      displayErrorMessage('Unable to navigate to dashboard');
    }
  };

  useRefreshAuthenticationFactors(() => {
    refreshPageContentCollection();
  }, [refreshPageContentCollection]);

  const authFactorRel = pageContentResource.withRelationship(
    fr.relationships.authenticationFactor.name,
    (rel) => rel,
    () => (<FDBodyText value={'Unable to load security settings.'} />),
  );

  const hasUserSettingsRevampRelationship = pageContentResource.withRelationship(
    fr.relationships.userSettingsSecurityPageRevamp.name,
    (_) => true,
    () => false,
  );

  // Avoids an unplug during logout
  if (!userResource) return null;

  return (
    <FDStack direction={'column'} alignItems={'stretch'} width={'100%'} spacing={2}>
      {userResource.withRelationship(fr.relationships.userAuthenticationSetup.name,
        () => {
          return (<AuthenticationFactorListOrganism
            authFactorsRelationship={authFactorRel}
            hasUserSettingsRevampRelationship={hasUserSettingsRevampRelationship}
          />);
        },
        () => {
          return (
            <AuthenticationFactorProvider>
              <Container />
            </AuthenticationFactorProvider>
          );
        })}
      {pageContentResource.withRelationship(fr.relationships.clientDashboard.name,
        (rel) => (
          <FDStack direction={'column'} alignItems={'center'}>
            <FDPrimaryActionButton
              label={rel.meta('prompt')}
              onClick={() => onClick(rel)}
              loading={loading}
            />
          </FDStack>),
        () => null) }
    </FDStack>
  );
};

export default AuthenticationFactorComponent;
